import React, { useState } from 'react';
import { TopCountriesTrafficWidget } from '../TopCountriesTrafficWidget/TopCountriesTrafficWidget';
import { ReportWidgetLoader } from '../ReportWidgetLoader';
import { BaseWidgetProps } from '../types';
import { Direction, ReportName } from '@src/utils/enums';

export const TopCountriesBlockedTrafficWidget: React.FC<BaseWidgetProps> = (props) => {
  const [direction, setDirection] = useState<Direction>(Direction.Inbound);

  return (
    <ReportWidgetLoader hookProps={{ ...props, reportName: 'topCountriesBlockedTraffic', direction }}>
      {(data, error) => (
        <TopCountriesTrafficWidget
          title="Top countries blocked traffic"
          color="#0A84FF"
          data={data}
          type="blocked"
          direction={direction}
          onDirectionChange={setDirection}
          reportPath={`/${props.customerId}/${props.serviceId}/insights/reports/${ReportName.TOP_15_BLOCKED_COUNTRIES}`}
          hasError={!!error}
        />
      )}
    </ReportWidgetLoader>
  );
};


